import React from "react"
import ReactMarkdown from "react-markdown"
import rehypeRaw from "rehype-raw"
import MetaImage from "./MetaImage"

const imageHandler = ({ node, component, src, ...props }) => {
  if (component?.toLowerCase() === "metaimage") {
    return (
      <div {...props}>
        <MetaImage image={src} alt={component?.toLowerCase()} />
      </div>
    )
  }
  return React.createElement("img", { src, ...props })
}

export default ({ children }) => (
  <ReactMarkdown
    rehypePlugins={[rehypeRaw]}
    children={children}
    components={{
      img: imageHandler,
    }}
  />
)
